<template>
    <div class="button-wrap">
        <button v-for="item in buttonArray" :class="item.className">{{item.text}}</button>
    </div>
</template>

<script>
export default {
    name: 'BottomButton',
    props : {
        buttonArray: Array
    },
};
</script>

<style lang="scss">
    @import '@/assets/styles/common/bottomButton.scss';
</style>